import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedataService } from './service/sharedata.service';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit,OnDestroy {
  public isCommaSapratedMails: boolean;
  constructor(public sService:SharedataService) { }

  ngOnInit() {
  }

  ngOnDestroy(){
    this.sService.close();
    this.sService.shareList = [];
    this.sService.uuid = '';
    this.sService.shareType = '';
    this.sService.sharingEmails = [];
    this.sService.showSuggestion = false;
    this.sService.suggestedEmails = '';
  }

  onSubmit(){
    this.selectCommaSapratedMails()
    let body = {
      "uuid":this.sService.uuid,
      "type":this.sService.shareType,
      "email":this.sService.sharingEmails,
    };
    if (body.uuid !='' && body.type !='' && body.email.length > 0) {
      this.sService.addShareData(body);
    }
  }

  selectSuggestion(){
    this.sService.sharingEmails.push(this.sService.suggestedEmails);
    this.sService.showSuggestion = false;
    this.sService.suggestedEmails = '';
  }

  deleteSelects(email){
    let index = this.sService.sharingEmails.indexOf(email);
    this.sService.sharingEmails.splice(index,1);
  }

  selectCommaSapratedMails(){
    if (this.isCommaSapratedMails) {
      let invalidMails = ""
      let mailList = this.sService.suggestedEmails.split(',');
      mailList.forEach(mail => {
        let trimmedStr = this.removeExtraSpaces(mail);
        if (!this.sService.sharingEmails.includes(trimmedStr)) {
          if(this.validateEmail(trimmedStr)){
            this.sService.sharingEmails.push(trimmedStr);
          }else{
            if (invalidMails == "") {
              invalidMails = invalidMails + trimmedStr;
            }else{
              invalidMails = invalidMails + ',' + trimmedStr;
            }
          }
        }
      });
      this.sService.suggestedEmails = invalidMails;
    }
  }

  validateCurrentEmail(e){
    this.isCommaSapratedMails = e.target.value.includes(',') ? true : false;
    if (this.isCommaSapratedMails) {
      this.sService.showSuggestion = false;
      // this.selectCommaSapratedMails();
    }else{
      let trimmedStr = this.removeExtraSpaces(e.target.value);
      if(this.validateEmail(trimmedStr)){
        this.sService.showSuggestion = true;
      } 
      else{
        this.sService.showSuggestion = false;
      }
    }
  }

  saveCurrentEmail(){
    if(this.sService.showSuggestion){
      this.selectSuggestion();
    }
  }

  removeExtraSpaces(str){
    return str.replace(/^[ ]+|[ ]+$/g,'');
  }

  validateEmail =(eml)=> /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(eml);
}
